import type { PlatformEligibility } from "./clientOnboardingPolicy";
import type { IssuerClientStatus } from "./issuerClient";

export const CLIENT_OPERATING_CONTEXT_HEADER = "x-issuer-client-context";

export type IssuerCapabilityStatus = "Active" | "Suspended";

export type ClientOperatingContextReadOnlyReason =
    | "IssuerCapabilitySuspended"
    | "IssuerClientSuspended"
    | "IssuerClientCancelled";

export type ClientOperatingContextErrorCode =
    | "CLIENT_OPERATING_CONTEXT_REQUIRED"
    | "CLIENT_OPERATING_CONTEXT_INVALID"
    | "OPERATING_CONTEXT_READ_ONLY";

export interface ClientOperatingContextSummary {
    issuerClientUuid: string;
    issuerOrganizationUuid: string;
    issuerOrganizationName: string;
    issuerCapabilityStatus: IssuerCapabilityStatus;
    status: IssuerClientStatus;
    platformEligibility?: PlatformEligibility;
    /**
     * The Distributor's pause / revoke on Platform Access, apart from
     * `status`: anything but Active closes the platform, as ineligibility
     * does. Absent from a yaas-api that predates it.
     */
    platformAccessState?: "Active" | "Paused" | "Revoked";
    defaultable: boolean;
    readOnly: boolean;
    readOnlyReason: ClientOperatingContextReadOnlyReason | null;
    isSelfClient: boolean;
    /**
     * The Distributor granted the Distributions access level and it is live
     * (it follows Platform Access): the console's Distributor section. Absent
     * from a yaas-api that predates it.
     */
    distributionsAccess?: boolean;
    /**
     * The Distributor granted the API Access level and it is live (it follows
     * Platform Access): the console's API keys. Absent from a yaas-api that
     * predates it.
     */
    apiAccess?: boolean;
}

export interface ClientOperatingContextListView {
    contexts: ClientOperatingContextSummary[];
    defaultContextUuid: string | null;
}

export interface OrgAuthIssuerCapabilitySummary {
    status: IssuerCapabilityStatus;
    grantedAt: string;
    suspendedAt: string | null;
    metadata: Record<string, unknown> | null;
    readOnly: boolean;
    writeBlockReason: string | null;
}
